import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class TableTransform extends EldmlTransform {
  apply() {
    this.selector.find("table").each(function (_: any, element: Element) {
      const table = $(element);
      if (table.attr("full-width") === "true") {
        table.css("width", "100%");
        table.css("min-width", "100%");
      }
    });
  }
}
